export function Select({ className = '', children, ...rest }: React.PropsWithChildren<React.SelectHTMLAttributes<HTMLSelectElement>>) {
    return (
        <select
            className={
                'appearance-none rounded-[4px] bg-midnight bg-[image:var(--select-arrow-svg)] bg-[length:15px_9px] bg-[position:calc(100%-10px)_center] bg-no-repeat text-ash-grey p-[6px] ' +
                className
            }
            {...rest}
        >
            {children}
        </select>
    );
}
